"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormattedDuration = exports.createPreviewVideoAssetOnMux = exports.getPartnerImageUrls = exports.getImageUrls = exports.getPdfUrls = exports.getVideoUrls = exports.createVideoAssetOnMux = exports.getMuxRequestHeaders = exports.MUX_DEFAULT_THUMBNAIL_TIMESTAMP = void 0;
var ascpectRatios_1 = require("./ascpectRatios");
var globals_1 = require("./globals");
var CLOUDINARY_MAPPED_FILES_FOLDER = process.env.CLOUDINARY_MAPPED_FILES_FOLDER ||
    process.env.STORYBOOK_CLOUDINARY_MAPPED_FILES_FOLDER ||
    process.env.GATSBY_CLOUDINARY_MAPPED_FILES_FOLDER ||
    process.env.SANITY_STUDIO_CLOUDINARY_MAPPED_FILES_FOLDER ||
    process.env.SANITY_STUDIO_PARTNER_LIBRARY_CLOUDINARY_MAPPED_FILES_FOLDER;
var CLOUDINARY_MAPPED_IMAGES_FOLDER = process.env.CLOUDINARY_MAPPED_IMAGES_FOLDER ||
    process.env.STORYBOOK_CLOUDINARY_MAPPED_IMAGES_FOLDER ||
    process.env.GATSBY_CLOUDINARY_MAPPED_IMAGES_FOLDER ||
    process.env.SANITY_STUDIO_CLOUDINARY_MAPPED_IMAGES_FOLDER ||
    process.env.SANITY_STUDIO_PARTNER_LIBRARY_CLOUDINARY_MAPPED_IMAGES_FOLDER;
var CLOUDINARY_MAPPED_PARTNER_IMAGES_FOLDER = process.env.CLOUDINARY_MAPPED_PARTNER_IMAGES_FOLDER ||
    process.env.STORYBOOK_CLOUDINARY_MAPPED_PARTNER_IMAGES_FOLDER ||
    process.env.GATSBY_CLOUDINARY_MAPPED_PARTNER_IMAGES_FOLDER ||
    process.env.SANITY_STUDIO_CLOUDINARY_MAPPED_PARTNER_IMAGES_FOLDER ||
    'partner_profile_images';
var CLOUDINARY_CLOUD_NAME = process.env.CLOUDINARY_CLOUD_NAME ||
    process.env.STORYBOOK_CLOUDINARY_CLOUD_NAME ||
    process.env.GATSBY_CLOUDINARY_CLOUD_NAME ||
    process.env.SANITY_STUDIO_CLOUDINARY_CLOUD_NAME ||
    process.env.SANITY_STUDIO_PARTNER_LIBRARY_CLOUDINARY_CLOUD_NAME;
var CLOUDINARY_BASE_URL = "".concat(globals_1.CLOUDINARY_HOSTNAME, "/").concat(CLOUDINARY_CLOUD_NAME, "/image/upload");
var CLOUDINARY_FALLBACK_IMAGE = 'fallback_emn3wg';
var MUX_DEFAULT_THUMBNAIL_TIMESTAMP = 6;
exports.MUX_DEFAULT_THUMBNAIL_TIMESTAMP = MUX_DEFAULT_THUMBNAIL_TIMESTAMP;
var MUX_VIDEO_UPLOAD_ENDPOINT = "".concat(globals_1.FUNCTIONS_ENDPOINT_URL_PREFIX, "muxVideoUpload");
// Get DEVICE_PIXEL_RATIO from device.
var FALLBACK_DPR = 2.0;
var DEVICE_PIXEL_RATIO = typeof window !== 'undefined'
    ? window.devicePixelRatio || FALLBACK_DPR
    : FALLBACK_DPR;
/**
 * Gets the width of the given HTML element and rounds it to full 100 pixels if the element is
 * wider than 100px or rounds to full 10 pixel if the element is smaller.
 *
 * @param element
 */
var getMediaWidth = function (element) {
    var FALLBACK_WIDTH = 500;
    var ROUNDING_SCALE_LARGE = 100;
    var ROUNDING_SCALE_SMALL = 10;
    var elementWidth = (element && element.scrollWidth) || FALLBACK_WIDTH;
    var widthRoundingScale = elementWidth > 100 ? ROUNDING_SCALE_LARGE : ROUNDING_SCALE_SMALL;
    return Math.ceil(elementWidth / widthRoundingScale) * widthRoundingScale;
};
/**
 * Returns the urls for requesting a video, video preview and preview image from mux.com.
 *
 * @param playbackId
 * @param previewPlaybackId
 * @param thumbTime
 */
var getVideoUrls = function (playbackId, previewPlaybackId, thumbTime) {
    if (thumbTime === void 0) { thumbTime = MUX_DEFAULT_THUMBNAIL_TIMESTAMP; }
    return ({
        videoUrl: "".concat(globals_1.MUX_STREAM_HOSTNAME, "/").concat(playbackId, ".m3u8"),
        videoPreviewUrl: "".concat(globals_1.MUX_STREAM_HOSTNAME, "/").concat(previewPlaybackId, ".m3u8"),
        previewImageUrl: "".concat(globals_1.MUX_IMAGE_HOSTNAME, "/").concat(playbackId, "/thumbnail.png?time=").concat(thumbTime),
    });
};
exports.getVideoUrls = getVideoUrls;
/**
 * Returns the urls for requesting a pdf from cloudinary.
 *
 * @param url
 * @param originalFilename
 * @param aspectRatio
 */
var getPdfUrls = function (url, originalFilename, aspectRatio) {
    if (aspectRatio === void 0) { aspectRatio = ascpectRatios_1.aspectRatios[ascpectRatios_1.RATIOS.RATIO_5_7].ratio; }
    var pdfFileName = url.split('/').pop();
    var attachmentFileName = originalFilename && originalFilename.replace(/\.pdf/, '');
    var previewFileName = pdfFileName && pdfFileName.replace(/\.pdf/, '');
    // Limits the size of the preview image.
    var PREVIEW_IMAGE_WIDTH = 640;
    var previewImageHeight = Math.ceil(PREVIEW_IMAGE_WIDTH * aspectRatio);
    var IMAGE_FORMAT_TRANSFORMATIONS = 'q_auto,f_png';
    var pdfUrl = "".concat(CLOUDINARY_BASE_URL, "/fl_attachment:").concat(attachmentFileName, "/").concat(CLOUDINARY_MAPPED_FILES_FOLDER, "/").concat(pdfFileName);
    var previewImageUrl = "".concat(CLOUDINARY_BASE_URL, "/c_limit,w_").concat(PREVIEW_IMAGE_WIDTH, ",h_").concat(previewImageHeight, "/ar_").concat(aspectRatio, ",c_fill,g_auto/").concat(IMAGE_FORMAT_TRANSFORMATIONS, "/v1/").concat(CLOUDINARY_MAPPED_FILES_FOLDER, "/").concat(pdfFileName);
    var previewImageFallbackUrl = "".concat(CLOUDINARY_BASE_URL, "/c_limit,w_").concat(PREVIEW_IMAGE_WIDTH, ",h_").concat(previewImageHeight, "/ar_").concat(aspectRatio, ",c_fill,g_auto/").concat(IMAGE_FORMAT_TRANSFORMATIONS, "/v1/").concat(CLOUDINARY_MAPPED_FILES_FOLDER, "/").concat(previewFileName);
    var previewImageNotFoundUrl = "".concat(CLOUDINARY_BASE_URL, "/ar_").concat(aspectRatio, ",c_fill/").concat(IMAGE_FORMAT_TRANSFORMATIONS, "/v1/").concat(CLOUDINARY_FALLBACK_IMAGE);
    return {
        pdfUrl: pdfUrl,
        previewImageUrl: previewImageUrl,
        previewImageFallbackUrl: previewImageFallbackUrl,
        previewImageNotFoundUrl: previewImageNotFoundUrl,
    };
};
exports.getPdfUrls = getPdfUrls;
/**
 * Returns the url for requesting the profile image of the given partner from cloudinary.
 *
 * @param partnerId
 * @param imageWidth
 */
var getPartnerImageUrls = function (partnerId, imageWidth) {
    if (imageWidth === void 0) { imageWidth = 100; }
    var imageFileName = "".concat(CLOUDINARY_MAPPED_PARTNER_IMAGES_FOLDER, "/").concat(partnerId, ".jpg");
    var imageUrl = "".concat(CLOUDINARY_BASE_URL, "/d_").concat(CLOUDINARY_MAPPED_PARTNER_IMAGES_FOLDER, ":fallback.png/ar_1,w_").concat(imageWidth, ",dpr_").concat(DEVICE_PIXEL_RATIO, ",c_thumb,g_face,z_0.8,q_auto,f_auto/v1/").concat(imageFileName);
    return {
        imageUrl: imageUrl,
    };
};
exports.getPartnerImageUrls = getPartnerImageUrls;
/**
 * Returns the url for requesting the sanity image asset from cloudinary.
 *
 * For more infos about the structure of the image asset see:
 * https://www.sanity.io/docs/image-type#df3f768ce073
 *
 * @param url - string looks like https://cdn.sanity.io/images/3do82whm/production/223c27c1f0e75fe1ef494333738e2d16a8539e6a-1365x1364.svg
 * @param imageElement
 * @param aspectRatio
 * @param withTransparentBackground
 */
var getImageUrls = function (url, imageElement, aspectRatio, withTransparentBackground) {
    if (aspectRatio === void 0) { aspectRatio = ascpectRatios_1.aspectRatios[ascpectRatios_1.RATIOS.RATIO_16_9].ratio; }
    if (withTransparentBackground === void 0) { withTransparentBackground = false; }
    var imageFileName = url.split('/').pop();
    var roundedAspectRatio = (0, ascpectRatios_1.roundAspectRatio)(aspectRatio);
    var imageWidth = getMediaWidth(imageElement);
    var transparentTransformation = withTransparentBackground
        ? ',e_make_transparent:8'
        : '';
    var imageUrl = "".concat(CLOUDINARY_BASE_URL, "/d_").concat(CLOUDINARY_FALLBACK_IMAGE, ".png/ar_").concat(roundedAspectRatio, ",w_").concat(imageWidth).concat(transparentTransformation, ",dpr_").concat(DEVICE_PIXEL_RATIO, ",c_fill,g_auto,q_auto,f_auto/v1/").concat(CLOUDINARY_MAPPED_IMAGES_FOLDER, "/").concat(imageFileName);
    return {
        imageUrl: imageUrl,
    };
};
exports.getImageUrls = getImageUrls;
/**
 * Returns the encrypted header to perform API calls to mux.com.
 */
var getMuxRequestHeaders = function () { return ({
    'Content-Type': 'application/json',
}); };
exports.getMuxRequestHeaders = getMuxRequestHeaders;
/**
 * Fetches the available asset info for the given MUX video asset id from mux.com.
 *
 * @param assetId
 * @param fetchFunction
 */
var getAssetDataFromMuxFunction = function (assetId_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([assetId_1], __read(args_1), false), void 0, function (assetId, fetchFunction) {
        var requestInit, parsedResponse, response, error_1;
        if (fetchFunction === void 0) { fetchFunction = fetch; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestInit = {
                        method: 'GET',
                        headers: getMuxRequestHeaders(),
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetchFunction("".concat(MUX_VIDEO_UPLOAD_ENDPOINT, "?assetId=").concat(assetId), requestInit)];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    parsedResponse = _a.sent();
                    if (!response || !parsedResponse) {
                        throw new Error('No response received.');
                    }
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/, parsedResponse];
            }
        });
    });
};
/**
 * Returns the available asset info for the given MUX video asset id from mux.com.
 * This function will wait until the asset on mux.com is in state `ready` before resolving.
 *
 * @param assetId
 * @param filename
 * @param fetchFunction
 */
var getAssetDataFromMuxForCompletedUpload = function (assetId_1, filename_1) {
    var args_1 = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args_1[_i - 2] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([assetId_1, filename_1], __read(args_1), false), void 0, function (assetId, filename, fetchFunction) {
        var intervalId;
        if (fetchFunction === void 0) { fetchFunction = fetch; }
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) {
                    var check = function () { return __awaiter(void 0, void 0, void 0, function () {
                        var assetData;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, getAssetDataFromMuxFunction(assetId, fetchFunction)];
                                case 1:
                                    assetData = _a.sent();
                                    if (assetData.status !== 'ready') {
                                        console.log(" ... Waiting for complete upload and processing of video \"".concat(filename, "\" at mux.com"));
                                    }
                                    else {
                                        // 2. ... return the asset data.
                                        window.clearInterval(intervalId);
                                        resolve(assetData);
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); };
                    check();
                    intervalId = window.setInterval(check, 2000);
                })];
        });
    });
};
/**
 * Uses a netlify function to create a new asset by pulling the video from
 * the sanityAssetUrl to MUX.
 *
 * @see https://docs.mux.com/api-reference/video#operation/create-asset
 *
 * @param sanityAssetUrl
 * @param fetchFunction
 */
var pullVideoFromSanityToMux = function (sanityAssetUrl_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([sanityAssetUrl_1], __read(args_1), false), void 0, function (sanityAssetUrl, fetchFunction) {
        var pullVideoFromSanityToMuxPayload, requestInit, error_2;
        if (fetchFunction === void 0) { fetchFunction = fetch; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    pullVideoFromSanityToMuxPayload = {
                        input: [
                            {
                                url: sanityAssetUrl,
                            },
                        ],
                    };
                    requestInit = {
                        method: 'POST',
                        headers: getMuxRequestHeaders(),
                        body: JSON.stringify(pullVideoFromSanityToMuxPayload),
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetchFunction(MUX_VIDEO_UPLOAD_ENDPOINT, requestInit)];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    error_2 = _a.sent();
                    console.error(error_2);
                    return [2 /*return*/, error_2];
                case 4: return [2 /*return*/];
            }
        });
    });
};
/**
 * Uses the given URL to create a video asset on mux.com.
 * This function will wait until the asset on mux.com is in state `ready` before resolving.
 *
 * @see https://docs.mux.com/guides/video/stream-video-files
 *
 * @param sanityAssetUrl
 * @param filename
 * @param fetchFunction
 */
var createVideoAssetOnMux = function (sanityAssetUrl_1, filename_1) {
    var args_1 = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args_1[_i - 2] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([sanityAssetUrl_1, filename_1], __read(args_1), false), void 0, function (sanityAssetUrl, filename, fetchFunction) {
        var response, parsedResponse, muxAssetId, error_3;
        if (fetchFunction === void 0) { fetchFunction = fetch; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    return [4 /*yield*/, pullVideoFromSanityToMux(sanityAssetUrl, fetchFunction)];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    parsedResponse = _a.sent();
                    muxAssetId = parsedResponse.data && parsedResponse.data.id;
                    return [4 /*yield*/, getAssetDataFromMuxForCompletedUpload(muxAssetId, filename, fetchFunction)];
                case 3: return [2 /*return*/, _a.sent()];
                case 4:
                    error_3 = _a.sent();
                    console.error(error_3);
                    return [2 /*return*/, null];
                case 5: return [2 /*return*/];
            }
        });
    });
};
exports.createVideoAssetOnMux = createVideoAssetOnMux;
/**
 * Creates a preview video of an existing MUX video asset at mux.com.
 *
 * @see https://docs.mux.com/guides/video/create-clips-from-your-videos
 *
 * @param assetId
 * @param startTime
 * @param fetchFunction
 */
var createPreviewVideoAssetOnMux = function (assetId_1, startTime_1) {
    var args_1 = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args_1[_i - 2] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([assetId_1, startTime_1], __read(args_1), false), void 0, function (assetId, startTime, fetchFunction) {
        var createPreviewPayload, requestInit, parsedResponse, response, error_4;
        if (fetchFunction === void 0) { fetchFunction = fetch; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    createPreviewPayload = {
                        input: [
                            {
                                url: "mux://assets/".concat(assetId),
                                start_time: startTime,
                                end_time: startTime + 5,
                            },
                        ],
                        playback_policy: ['public'],
                        mp4_support: 'standard',
                    };
                    requestInit = {
                        method: 'PUT',
                        headers: getMuxRequestHeaders(),
                        body: JSON.stringify(createPreviewPayload),
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetchFunction(MUX_VIDEO_UPLOAD_ENDPOINT, requestInit)];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    parsedResponse = _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    error_4 = _a.sent();
                    console.error(error_4);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/, getAssetDataFromMuxForCompletedUpload(parsedResponse.data.id, "Preview video for ".concat(assetId), fetchFunction)];
            }
        });
    });
};
exports.createPreviewVideoAssetOnMux = createPreviewVideoAssetOnMux;
/**
 * Helper to format the given seconds to the format hh:mm:ss
 *
 * @param seconds
 */
var getFormattedDuration = function (seconds) {
    var hours = Math.floor(seconds / 60 / 60);
    var minutes = Math.floor(seconds / 60) - hours * 60;
    var remainingSeconds = Math.floor(seconds % 60);
    var padTime = function (value) { return value.toString().padStart(2, '0'); };
    return "".concat(padTime(hours), ":").concat(padTime(minutes), ":").concat(padTime(remainingSeconds));
};
exports.getFormattedDuration = getFormattedDuration;
